import { createRef, Component, Fragment } from 'react';

import GroceryList from './GroceryList';
import MealPlans from './MealPlans';
import TabSelector from '../generic/TabSelector';

import NavbarReplacer from '../generic/NavbarReplacer';
import { inUrlHash } from '../utils/utils';
import PropTypes from 'prop-types';

import {
  togglePdpModal,
  getCustomerAC,
  getSpicyTagsAC,
  toggleRdpModal,
} from '../generic/global_state/action_creators';
import { toggleCyoModal } from './cyo_redux/cyo_actions_creators';
import { connect } from 'react-redux';
import OrderDetailsModals from './OrderDetailsModals';

import { getCustomerCyo } from '../api/api';
import { PAGES } from '../constants/order_details';
import { recipeFavoritedChange } from '../../../../components/SaveRecipes/favorites.reducer';
import { bindActionCreators } from 'redux';
import OrderWrapper from './OrderWrapper';
import styles from './Base.module.css';

class Base extends Component {
  constructor(props) {
    super(props);
    this.state = {
      order: {},
      tab: inUrlHash('grocery-list') ? 1 : 0,
      loading: true,
      error: false,
      showLoadingIcon: false,
      customerCyo: null,
      bundledOrder: null,
    };
    this.tabOptions = [
      {
        value: 0,
        text: 'Meal plan',
        iconClassName: 'meals',
      },
      {
        value: 1,
        text: 'Your groceries',
        iconClassName: 'groceries',
      },
    ];
    this.windowScrollPos = 0;
    this.firstPosition = createRef();
    this.isUpcoming = props.page === PAGES.upcoming;
  }

  setOrderPairingFavorites(order) {
    const { recipeFavoritedChange } = this.props;
    order.pairings.forEach((pairing) => {
      const { is_favorited, id: pairingId } = pairing;
      if (is_favorited !== undefined) {
        recipeFavoritedChange(pairingId, is_favorited);
      }
    });
  }

  getOrderAfterLoad() {
    let { getOrder, order } = this.props;
    if (order) {
      this.setOrderPairingFavorites(order);
      this.setState({ order: order, loading: false, showLoadingIcon: false });
    } else if (getOrder) {
      getOrder()
        .then((responseOrder) => {
          this.setOrderPairingFavorites(responseOrder);
          this.setState(
            { order: responseOrder, loading: false, showLoadingIcon: false },
            () => {
              if (this.isUpcoming && this.state.order.promo_has_cyo_free_item) {
                this.renderCustomerCyo();
              }
            }
          );
        })
        .catch((err) => {
          this.setState({
            error: true,
            loading: false,
            showLoadingIcon: false,
          });
        });
    }
  }

  renderCustomerCyo() {
    if (this.isUpcoming) {
      getCustomerCyo()
        .then((customerCyo) => {
          if (customerCyo['cyo_promo']) {
            this.setState({ customerCyo });
          }
        })
        .catch(console.error);
    }
  }

  componentDidMount() {
    //saving the window Y position for first tab change
    this.windowScrollPos = this.firstPosition.current
      ? $(this.firstPosition.current).position().top
      : 0;
    // If set the order to the state:
    this.setState({ showLoadingIcon: true });
    this.getOrderAfterLoad();
    this.props.getCustomer();
    this.props.getSpicyTags();
  }

  changeTab(val) {
    this.scrollToPreviousPos();
    this.setState({
      tab: val,
    });
  }

  scrollToPreviousPos() {
    if ($(window).scrollTop() <= $(this.firstPosition.current).position().top) {
      //reset windowScrollPos
      this.windowScrollPos = $(this.firstPosition.current).position().top;
      return;
    }
    let scrollTo = this.windowScrollPos;
    this.windowScrollPos = $(window).scrollTop();
    if (scrollTo) window.scrollTo(0, scrollTo);
  }

  renderMealPlansComponent(order) {
    return (
      <MealPlans
        customer={this.props.customer}
        pairings={order?.pairings}
        occasions={order?.occasions}
        orderId={order?.id}
        togglePdpModal={this.props.togglePdpModal}
        toggleRdpModal={this.props.toggleRdpModal}
        toggleCyoModal={this.props.toggleCyoModal}
        page={this.props.page}
        customerCyo={this.state.customerCyo}
      />
    );
  }

  renderGroceryListComponent(order) {
    return (
      order?.grocery_items && (
        <GroceryList
          groceryItems={order.grocery_items}
          freeItem={!!order.promo_product && this.props.showFreeItem}
          freeItemEffect={order.promo_effect_free_item}
          promoHasNonCYOFreeItem={order.promo_has_non_cyo_free_item}
          loading={this.state.loading}
          togglePdpModal={this.props.togglePdpModal}
          page={this.props.page}
          customerCyo={this.state.customerCyo}
        />
      )
    );
  }

  renderBody() {
    let currentTab = this.state.tab;
    let { children } = this.props;
    return (
      <div className={`body-container`}>
        {this.state.showLoadingIcon ? (
          <img
            className={'loading-gif'}
            src={`/public/img/edit_delivery/load.svg`}
            alt="Loading icon"
          />
        ) : (
          <OrderWrapper order={this.state.order}>
            {(order) => {
              return (
                <Fragment>
                  <div className={styles['hr-mobile']}>
                    {children || null}
                    <div ref={this.firstPosition}></div>
                    <NavbarReplacer>
                      <TabSelector
                        tabOptions={this.tabOptions}
                        changeTab={(val) => this.changeTab(val)}
                        selectedTab={currentTab}
                      />
                    </NavbarReplacer>
                    <section
                      id="recipe-grocery-section"
                      className="hr-base-width hr-plr-32"
                    >
                      <div className={currentTab === 1 ? 'hr-hidden' : ''}>
                        {this.renderMealPlansComponent(order)}
                      </div>
                      <div className={currentTab === 0 ? 'hr-hidden' : ''}>
                        {this.renderGroceryListComponent(order)}
                      </div>
                    </section>
                  </div>
                  <div className={styles['hr-desktop']}>
                    <section
                      id="recipe-grocery-section"
                      className="hr-base-width hr-plr-32"
                    >
                      <div className="recipe-section new">
                        <div className="title-box hr-ptb-32 hr-mb-32 hr-title-sectra">
                          Your meal plan:
                        </div>
                        {this.renderMealPlansComponent(order)}
                      </div>
                      <div
                        id="grocery_list_section"
                        className="sku-section new"
                      >
                        <div className="title-box hr-ptb-32 hr-mb-32 hr-title-sectra">
                          Your groceries:
                        </div>
                        {!this.state.loading
                          ? this.renderGroceryListComponent(order)
                          : null}
                      </div>
                    </section>
                  </div>

                  <OrderDetailsModals
                    renderCustomerCyo={() => this.renderCustomerCyo()}
                  />
                </Fragment>
              );
            }}
          </OrderWrapper>
        )}
      </div>
    );
  }

  render() {
    return (
      <Fragment>
        {this.state.error ? (
          <div>Sorry something has gone wrong</div>
        ) : (
          this.renderBody()
        )}
      </Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    togglePdpModal: (p) => dispatch(togglePdpModal(p)),
    toggleRdpModal: (p) => dispatch(toggleRdpModal(p)),
    toggleCyoModal: () => dispatch(toggleCyoModal()),
    getCustomer: () => dispatch(getCustomerAC('pricing_config')),
    getSpicyTags: () => dispatch(getSpicyTagsAC()),
    recipeFavoritedChange: bindActionCreators(recipeFavoritedChange, dispatch),
  };
};

export default connect((state) => {
  return {
    customer: state.customer,
  };
}, mapDispatchToProps)(Base);

Base.propTypes = {
  getOrder: PropTypes.func,
  noPdp: PropTypes.bool,
  order: PropTypes.object,
  page: PropTypes.string,
};
